var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4395 14.3083C15.749 14.6178 15.749 15.1199 15.4344 15.4344C15.122 15.7468 14.6137 15.7449 14.3083 15.4396L12.0349 13.1668C11.7254 12.8573 11.7254 12.3552 12.04 12.0404C12.3524 11.7278 12.8607 11.7295 13.1661 12.0349L15.4395 14.3083ZM1.6 6.4C1.6 3.7536 3.7536 1.6 6.4 1.6C9.0464 1.6 11.2 3.7536 11.2 6.4C11.2 9.0472 9.0464 11.2 6.4 11.2C3.7536 11.2 1.6 9.0472 1.6 6.4ZM0 6.4C0 9.9344 2.8656 12.8 6.4 12.8C9.9344 12.8 12.8 9.9344 12.8 6.4C12.8 2.8656 9.9344 0 6.4 0C2.8656 0 0 2.8656 0 6.4Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNew);
export default __webpack_public_path__ + "static/media/searchNew.29050f5ba257f49c13baa72aba7c3d67.svg";
export { ForwardRef as ReactComponent };